import React, { useContext } from "react";
import { Box, Paper, Typography } from "@mui/material";
import ReportProblemOutlinedIcon from "@mui/icons-material/ReportProblemOutlined";
import { ConfiguratorContext } from "../../../contexts/ConfiguratorContext";
import {
  INTERNET_STOP_LOAN_MESSAGE_KEY,
  INTERNET_STOP_LOAN_DEFAULT_MESSAGE,
  USER_ACCOUNT_REQUIREMENTS_TENANT_PHONE_NUMBER_KEY,
  USER_ACCOUNT_REQUIREMENTS_TENANT_CONTACT_URL_KEY,
} from "../../constants/Configurator.constants";
import { formatPhoneNumber } from "../../utils/utility-functions";

/**
 * Access block shown when the active loan carries an Elevate Internet Stop Flag
 * of "1" (US-1062468). Renders in place of the page content with a greyed,
 * blurred backdrop so the borrower cannot access or transact on the loan. The
 * global navbar remains available so a borrower with other (non-stopped) loans
 * can switch to them.
 */
const InternetStopNotice = () => {
  const { edittedFields } = useContext(ConfiguratorContext);

  const rawPhoneNumber =
    edittedFields.find(
      (item) => item.key === USER_ACCOUNT_REQUIREMENTS_TENANT_PHONE_NUMBER_KEY,
    )?.value || "";
  const contactUrl =
    edittedFields.find(
      (item) => item.key === USER_ACCOUNT_REQUIREMENTS_TENANT_CONTACT_URL_KEY,
    )?.value || "";
  const phoneNumber = rawPhoneNumber
    ? formatPhoneNumber(rawPhoneNumber)
    : "";

  let template =
    edittedFields.find((item) => item.key === INTERNET_STOP_LOAN_MESSAGE_KEY)
      ?.value || INTERNET_STOP_LOAN_DEFAULT_MESSAGE;

  if (!contactUrl) {
    template = template.replace(
      /at\s*\{USER_ACCOUNT_REQUIREMENTS_TENANT_CONTACT_URL\}\s*(or\s+)?/gi,
      "",
    );
  }
  if (!phoneNumber) {
    template = template.replace(
      /(or\s+)?call\s*\{USER_ACCOUNT_REQUIREMENTS_TENANT_PHONE_NUMBER\}/gi,
      "",
    );
  }

  const message = template
    .split("{USER_ACCOUNT_REQUIREMENTS_TENANT_CONTACT_URL}")
    .join(contactUrl)
    .split("{USER_ACCOUNT_REQUIREMENTS_TENANT_PHONE_NUMBER}")
    .join(phoneNumber)
    .replace(/\s{2,}/g, " ")
    .replace(/\s+([.,])/g, "$1")
    .replace(/,\s*\./g, ".")
    .trim();

  return (
    <Box
      role="alert"
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: "100%",
        minHeight: "60vh",
        padding: "24px",
        boxSizing: "border-box",
        backdropFilter: "blur(3px)",
        backgroundColor: "rgba(0, 0, 0, 0.06)",
      }}
    >
      <Paper
        elevation={3}
        sx={{
          maxWidth: 640,
          width: "100%",
          padding: { xs: "24px", md: "40px" },
          textAlign: "center",
          borderTop: "6px solid",
          borderTopColor: "warning.main",
        }}
      >
        <ReportProblemOutlinedIcon
          color="warning"
          sx={{ fontSize: 56, marginBottom: "12px" }}
        />
        <Typography
          variant="h2"
          color="primary"
          fontSize="1.5rem"
          fontWeight="bold"
          gutterBottom
        >
          Loan Unavailable
        </Typography>
        <Typography fontSize="1.05rem" lineHeight={1.6} whiteSpace="pre-line">
          {message}
        </Typography>
      </Paper>
    </Box>
  );
};

export default InternetStopNotice;
